import { Component, OnInit } from '@angular/core';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';
import { MenuItem,MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { TokenService } from 'src/app/services/common/token.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
@Component({
  selector: 'app-vendor-farmer-application',
  templateUrl: './vendor-farmer-application.component.html',
  styleUrls: ['./vendor-farmer-application.component.scss']
})
export class VendorFarmerApplicationComponent implements OnInit {
  vendorMobile: any;
  vendorData: any;
  appVerificationItems: MenuItem[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public loading: boolean = false;
  constructor(
    private vendorService:VendorDashboardService, 
    private translateService: TranslateService, 
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService
    ) { }

  ngOnInit(): void {
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.vendorData, "Vendor_Farmer_Application_List");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.vendorData, "Vendor_Farmer_Application_List");
        }
      },
    ];
    this.loadData();
  }
  refreshTable() {
    
    this.loadData();
  }

  loadData() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.vendorMobile = JSON.parse(payload)?.sub;

    // this.loader.start();
    this.loading = true;
    this.vendorService
      .getFarmerDashboardDataForVendor(this.vendorMobile)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(this.vendorMobile, 'Farmer Application', '', new Date(), 'Success');
          data.forEach((e,i)=>{
            e.srNo=i+1;
            e.dt_reg_sort=new Date(e.dt_reg.substr(3,2)+"/"+e.dt_reg.substr(0,2)+"/"+e.dt_reg.substr(6))
          })
          // console.log('Response Data', data);
          if(data.length>0){
            this.vendorData = data;
          }
          else{
            this.vendorData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
         
          // this.loader.close();
          this.loading = false;
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.vendorMobile, 'Farmer Application', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Dashboard not loaded.',
          });
        },
      });
  }
  
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "APP ID":d.AppID,
          "Programme Name":d.ProgrammeName, 
          "Farmer Name":d.farmerName,
          "Village":d.Village, 
          "Block":d.block, 
          "District":d.district,  
          "Mobile":d.Mobile, 
          "Address":d.Address, 
          "Date of Registration":d.dt_reg, 
          "Total Area":d.Total_Area,
          "Current Status":d.Current_Status,
          "Remarks":d.Remarks,
          "Status":d.Status,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'AppID', header: 'APP ID' },
      { field: 'ProgrammeName', header: 'Programme Name' },
      { field: 'farmerName', header: 'Farmer Name' },
      { field: 'Village', header: 'Village' },
      { field: 'block', header: 'Block' },
      { field: 'district', header: 'District' },
      { field: 'Mobile', header: 'Mobile' },
      { field: 'Address', header: 'Address' },
      { field: 'dt_reg', header: 'Date of Registration' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'Current_Status', header: 'Current Status' },
      { field: 'Remarks', header: 'Remarks' },
      { field: 'Status', header: 'Status' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
}
